import React from 'react'
import '../assets/style.css'
import {Link} from 'react-router-dom'
import UseSend from '../hooks/useSend'
import {useState,useEffect} from 'react'
interface Error{
  error:string
  email:string
}
function Register() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [first_name,setFirstName] = useState('')
  const [last_name,setLastName] = useState('')
  const [isValid,setIsValid] = useState('')
  const [buttonStatus,setButtonStatus] = useState<boolean>(false)


  const { data, getData,error,message } = UseSend({ email, password,first_name,last_name});
  // console.log(error)
  useEffect(()=>{
    console.log(error)

  },[data,error])
  const sendHandler= ()=>{
    getData()

    if(first_name ==''){
     setIsValid('error')
    }
    if(password == ''){
      setIsValid('error')
    }
    if(last_name ==''){
      setIsValid('error')
    }
    if(isValid){
      setButtonStatus(false)

      //  getData()
    }
   
  }
  return (
    <div className='container'>
        <div className='loginContainer'>
            <h3>Register</h3>
            <p>after clicking register waite for 5 second</p>
            {error && error.length > 0 && <div className="alert alert-danger" role="alert">{error}</div>}
            {message && message.length >0 && <div className="alert  alert-success" role="alert">{message}</div>}
            <div className='inputContainer'>
            <label htmlFor='email'>Email</label>
            <input type='email' placeholder='Email' id='email' onChange={(e)=>setEmail(e.target.value)}/> 
            </div>
         
           <div className='inputContainer'>
            <label htmlFor='password'>Password</label>
            <input type='password' placeholder='password' id='password' onChange={(e)=> setPassword(e.target.value)}/> 
            </div>
            <div className='inputContainer'>
            <label htmlFor='first_name'>first name</label>
            <input type='text' placeholder='first name' id='first_name' onChange={(e) =>setFirstName(e.target.value)}/> 
            </div>
            <div className='inputContainer'>
            <label htmlFor='last_name'>Last Name</label>
            <input type='text' placeholder='last name' id='last_name' onChange={(e)=> setLastName(e.target.value)}/> 
            </div>
         <button className='loginBtn' onClick={sendHandler} disabled={buttonStatus}>Register</button>
          <Link to='/login'>Already have an account</Link>
          {isValid !==''? <p className='error'>All fields are required</p> :''}
        </div>
 
    </div>
  )
}

export default Register
